import { useState } from 'react'
import classNames from 'classnames'

import Typography, { TypographyTag, TypographyVariant } from '~/components/Typography'
import { TabGroups } from '../TabGroups'
import { TabGroupOption, TabGroupsSelector } from '../TabGroups/TabGroupsSelector'
import styles from './ProductDashboardSpecifications.module.scss'
import { ProductSpecification } from 'shared-types'


export interface ProductDashboardSpecificationsProps {
  specification?: ProductSpecification[]
}

export const ProductDashboardSpecifications = ({
  specification,
}: ProductDashboardSpecificationsProps) => {
  const tabs: TabGroupOption[] = [
    { id: 'specifications', name: 'Specifications' },
  ]

  const [selectedTabId, setSelectedTabId] = useState<string>(tabs[0].id)
  const [selectedGroupIndex, setSelectedGroupIndex] = useState<number>(0)

  const selectedGroup = specification?.[selectedGroupIndex]

  return (
    <div className={styles.root}>
      <TabGroups>
        <TabGroupsSelector
          selectedTabId={selectedTabId}
          setSelectedTabId={setSelectedTabId}
          tabs={tabs}
        />
        <div className={styles.content}>
          {selectedTabId === 'specifications' && (
            <>
              {specification && specification.length > 1 && (
                <div className={styles.groupPills}>
                  {specification.map((group, index) => {
                    return (
                      <button
                        key={index}
                        className={classNames(styles.groupPill, {
                          [styles.groupPillActive]: selectedGroupIndex === index,
                        })}
                        onClick={() => {
                          setSelectedGroupIndex(index)
                        }}
                      >
                        <Typography
                          variant={TypographyVariant.BodyRegularBold}
                          tag={TypographyTag.span}
                          className={styles.groupPillLabel}
                        >
                          {group.title}
                        </Typography>
                      </button>
                    )
                  })}
                </div>
              )}
              <div className={styles.attributeGrid}>
                {selectedGroup?.attributes.map((attribute, index) => {
                  return (
                    <div key={index} className={styles.attributeCard}>
                      <Typography
                        variant={TypographyVariant.BodyRegularBold}
                        tag={TypographyTag.span}
                        className={styles.attributeName}
                      >
                        {attribute.title}:
                      </Typography>
                      <Typography
                        variant={TypographyVariant.BodyRegular}
                        tag={TypographyTag.span}
                        className={styles.attributeValue}
                      >
                        {`${attribute.value ?? '—'}`}
                      </Typography>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </TabGroups>
    </div>
  )
}
